// AY `userState` packs `<engagement>:<hemProvider>`. The user-segment and user-identity
// plugins each own one part, so both record it here and read the full value when they write.
let engagement: string | null = null
let hemProvider: string | null = null

export function setUserStateEngagement(value: string): void {
  engagement = value
}

export function setUserStateHemProvider(value: string | null): void {
  hemProvider = value
}

/** `isEngaged`, `isEngaged:retention`, or `:retention` on tenants without engagement tracking. */
export function currentUserState(): string | null {
  if (!hemProvider) return engagement
  return `${engagement ?? ''}:${hemProvider}`
}
